import React from 'react';
import { useFelaEnhanced } from '@ackee/fela';

import { ContainerType, DynamicContainer, Title, TitleTypes } from '../../../../ui';
import type { BlogPostDetail } from '../../../types';
import { BlogBackLink } from '../../BlogBackLink';
import { BlogPostMeta } from '../../BlogPostMeta';

import * as felaRules from './Hero.rules';

export interface HeroProps {
    title: BlogPostDetail['title'];
    author: BlogPostDetail['author'];
    thumbnail: BlogPostDetail['thumbnail'];
    categories: BlogPostDetail['categories'];
    publishedAt: BlogPostDetail['publishedAt'];
}

export const Hero = ({ title, author, thumbnail, categories, publishedAt }: HeroProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules);

    return (
        <DynamicContainer as={ContainerType.HEADER} isFluid extend={{ container: rules.container }}>
            <div className={styles.contentContainer}>
                <BlogBackLink />
                {/** @ts-expect-error */}
                <Title type={TitleTypes.H3} as={TitleTypes.H1}>
                    {title}
                </Title>
                {/** @ts-expect-error */}
                <Title as={TitleTypes.H2}>
                    <BlogPostMeta author={author} categories={categories} publishedAt={publishedAt} />
                </Title>
            </div>
            {thumbnail && (
                <div className={styles.imageContainer}>
                    <img src={thumbnail.formats.large?.url ?? thumbnail.url} className={styles.image} alt="" />
                </div>
            )}
        </DynamicContainer>
    );
};
